import api from '@/api'

export default {
    getMyPeoples(request: graph.PeopleRequest): Promise<graph.PeopleResponse> {
        return api.post({ 
            url: '/Graph/User/api/GetMyPeoples',
            data: request
         })
    },


    getMyTeams(upn: string): Promise<graph.TeamsGroup[]> {
        return api.get({ 
            url: '/Graph/Teams/api/GetTeams',
            params: {
                upn: upn
            }
        })
    },

    getRecentFiles(): Promise<graph.DriveItem[]> {
        return api.get({ url: '/Graph/Drive/api/GetRecentFiles' })
    },

    getDriveItems(request: graph.DriveItemsRequet): Promise<graph.DriveItem[]> {
        return api.post({
            url: '/Graph/Drive/api/GetDriveItems',
            data: request
        })
    }
}